import MasterCardImgFlipParty from "../components/MasterCardImgFlipParty";

const PartyBag = () => {
    return (
      <MasterCardImgFlipParty />
    );
}

export default PartyBag;